import React from "react";
import { Link } from "react-router-dom";

const Latest = () => {
  return (
    <div className="latest">
      <div className="header">Latest Posts</div>
      <ul>
        <li>
          <Link className="latestLink" to={"/blog/What-is-the-CDR-Writing-Process-for-Engineers-Australia?"}>
            What is the CDR Writing Process for Engineers Australia?
          </Link>
        </li>
        <li>
          <Link className="latestLink" to={"/blog/How-can-you-get-an-Australian-Onshore-Visa?"}>
            How can you get an Australian Onshore Visa?
          </Link>
        </li>
        <li>
          <Link className="latestLink" to={"/blog/Your-Complete-Guide-to-the-KA02-Knowledge-Assessment-(2024-Edition)"}>
            Your Complete Guide to the KA02 Knowledge Assessment (2024 Edition)
          </Link>
        </li>
        <li>
          <Link className="latestLink" to={"/blog/List-of-Courses-that-Helps-to-Migrate-Engineers-to-Australia-in-2023."}>
            List of Courses that Helps to Migrate Engineers to Australia in 2023.
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Latest;
